module.exports = __webpack_public_path__ + "static/autumn-6552212fb7fe4def2833035e70008ed4.jpg";